import {makeApiRequest} from './api';

export type ApiObservations = {
  units: Partial<{[key in FlowType]: Unit}>;
  datetime: string[];
} & Partial<{[key in FlowType]: number[]}>;

export const FLOW_TYPES = ['inflow', 'outflow', 'flow'] as const;
export type FlowType = (typeof FLOW_TYPES)[number];

export const UNIT_OPTIONS = ['cms', 'cfs'];
export type Unit = (typeof UNIT_OPTIONS)[number];

export async function uploadObservations(observations: ApiObservations, siteId: string) {
  const response = await makeApiRequest<ApiObservations>(
    `api/v1/observations/${siteId}`,
    {},
    {
      method: 'PUT',
      body: JSON.stringify(observations),
    }
  );
  return response;
}
